import * as React from 'react';

/**
 * Force update functional component.
 * Useful, for example, to subscribe to observable-like
 */
export function useForceUpdate() {
  const [, next] = React.useState(0);
  return React.useCallback(() => {
    next((prev) => prev + 1);
  }, []);
}
